export const THREAD_ID_CHANGED = 'THREAD_ID_CHANGED';
export const SEED_THREAD_HISTORY = 'SEED_THREAD_HISTORY';